import React from 'react';
import { logos } from './trustedLogos';
import classes from './LogoBar.module.css';

type LogoBarProps = {};

export const LogoBar: React.FC<LogoBarProps> = () => {
  return (
    <div>
      <div className="text-center">Used by NHS Trusts, medical schools and societies across the UK</div>
      <div className={classes.LogoBar}>
        <div className={classes.LogoBarInner}>
          {logos.map((company) => (
            <img key={company.name} src={company.src} alt={company.name} height={company.height} />
          ))}
        </div>
      </div>
    </div>
  );
};
